import { SERVICES } from "./services-data";
export { SERVICES };

// Brand constants and static content for KINFLEX HOME HEALTHCARE
export const BRAND = {
  name: "KinFlex Home Healthcare",
  shortName: "KinFlex",
  tagline: "24×7 Home Healthcare Services in Delhi NCR",
  logo: "https://customer-assets.emergentagent.com/job_c6db479d-f053-4142-8fe3-95cbdea25844/artifacts/s6a1d4kc_IMG-20260505-WA0002.jpg",
  domain: "kinflexhomehealthcare.com",
  email: "info@kinflexhomehealthcare.com",
};

export const PHONES = ["8796465422", "8755919609", "6396273005", "9001069389"];
export const PRIMARY_PHONE = "8796465422";
export const WHATSAPP_URL = "https://wa.me/918796465422";
export const WHATSAPP_QR = "https://wa.me/qr/TPPBFU6HIVIBO1";

export const SOCIALS = {
  instagram: "https://www.instagram.com/kinflexhomehealthcare",
  linkedin: "https://www.linkedin.com/in/kinflex-home-healthcare-677993408",
  youtube: "https://youtube.com/@kinflexhomehealthcare",
};


// ===== EQUIPMENT catalog =====
export const EQUIPMENT = [
  { name: "Hospital Bed (Semi-Fowler)", desc: "Adjustable back-rest & knee-rest with side rails.", icon: "BedDouble" },
  { name: "Fully-Motorised ICU Bed", desc: "5-function electric ICU-grade bed with mattress.", icon: "BedDouble" },
  { name: "Oxygen Concentrator", desc: "5L / 10L medical-grade concentrators, dual flow.", icon: "Wind" },
  { name: "Oxygen Cylinder", desc: "Portable D-type oxygen cylinders with regulator.", icon: "Zap" },
  { name: "Ventilator", desc: "Portable ICU ventilators with humidifier.", icon: "MonitorSmartphone" },
  { name: "BiPAP / CPAP Machine", desc: "Non-invasive ventilation for sleep apnoea & respiratory care.", icon: "Activity" },
  { name: "Multi-Para Monitor", desc: "ECG, SpO₂, NIBP, temperature — 5-para monitor.", icon: "HeartPulse" },
  { name: "Suction Machine", desc: "Electric suction apparatus with sterile bottles.", icon: "Droplets" },
  { name: "Wheelchair", desc: "Standard, reclining, and commode wheelchairs.", icon: "Accessibility" },
  { name: "Walker & Crutches", desc: "Adjustable aluminium walkers & crutches.", icon: "Move" },
  { name: "Air Mattress", desc: "Anti-decubitus alternating pressure mattress.", icon: "Sparkles" },
  { name: "Nebulizer", desc: "Compressor & mesh nebulizers for home use.", icon: "Wind" },
];

// ===== 6 LOCATIONS =====
export const LOCATIONS = [
  {
    slug: "delhi",
    name: "Delhi",
    tagline: "Trusted home healthcare across Delhi.",
    coverage: "New Delhi, South Delhi, East Delhi, West Delhi, North Delhi",
    pincodes: "110001 – 110096",
    image: "https://images.unsplash.com/photo-1587474260584-136574528ed5?q=80&w=1600&auto=format&fit=crop",
    responseTime: "Within 2–4 hours",
    description:
      "KinFlex delivers premium home nursing, critical care, physiotherapy and elder care across every Delhi zone. Our verified nurses are stationed across the city for rapid deployment — same day for most bookings.",
    landmarks: ["Saket", "Vasant Kunj", "Dwarka", "Rohini", "Karol Bagh", "Lajpat Nagar", "Preet Vihar", "Rajouri Garden"],
  },
  {
    slug: "noida",
    name: "Noida",
    tagline: "Premium home healthcare in Noida.",
    coverage: "All Noida sectors including Sector 18, 62, 137, 150",
    pincodes: "201301 – 201310",
    image: "https://images.unsplash.com/photo-1587474260584-136574528ed5?q=80&w=1600&auto=format&fit=crop",
    responseTime: "Within 2 hours",
    description:
      "From Sector 15 to Sector 150, KinFlex serves families across Noida with certified nurses, physiotherapists, and 24×7 emergency care. Same-day visits available across all sectors.",
    landmarks: ["Sector 18", "Sector 50", "Sector 62", "Sector 137", "Sector 150", "Sector 76"],
  },
  {
    slug: "greater-noida",
    name: "Greater Noida",
    tagline: "Home healthcare in Greater Noida.",
    coverage: "Alpha, Beta, Gamma, Zeta, Omicron, Chi Sectors + Pari Chowk area",
    pincodes: "201306 – 201310",
    image: "https://images.unsplash.com/photo-1587474260584-136574528ed5?q=80&w=1600&auto=format&fit=crop",
    responseTime: "Within 3 hours",
    description:
      "KinFlex serves the entire Greater Noida belt with home nursing, critical care and elder care. Our nurses reach families across Alpha, Beta, Gamma, and beyond — including the Yamuna Expressway sectors.",
    landmarks: ["Alpha 1 & 2", "Beta 1 & 2", "Gamma", "Zeta", "Pari Chowk", "Knowledge Park"],
  },
  {
    slug: "ghaziabad",
    name: "Ghaziabad",
    tagline: "Reliable home healthcare in Ghaziabad.",
    coverage: "Indirapuram, Vaishali, Kaushambi, Raj Nagar, Vasundhara, Crossings Republik",
    pincodes: "201001 – 201017",
    image: "https://images.unsplash.com/photo-1587474260584-136574528ed5?q=80&w=1600&auto=format&fit=crop",
    responseTime: "Within 3 hours",
    description:
      "KinFlex nurses cover all Ghaziabad — Indirapuram, Vaishali, Kaushambi, Vasundhara and beyond. Whether you need short-term post-op care or long-term elder care, we're a call away.",
    landmarks: ["Indirapuram", "Vaishali", "Kaushambi", "Vasundhara", "Raj Nagar", "Crossings Republik"],
  },
  {
    slug: "gurugram",
    name: "Gurugram",
    tagline: "Premium home healthcare in Gurugram.",
    coverage: "DLF Phases 1–5, Sushant Lok, Golf Course Road, MG Road, Sohna Road, New Gurgaon",
    pincodes: "122001 – 122018",
    image: "https://images.unsplash.com/photo-1587474260584-136574528ed5?q=80&w=1600&auto=format&fit=crop",
    responseTime: "Within 2–3 hours",
    description:
      "From DLF Phase 1 to Sohna Road, KinFlex serves Gurugram families with premium home healthcare. Our certified critical care nurses, physiotherapists and doctors visit across the city.",
    landmarks: ["DLF Phase 1–5", "Golf Course Rd", "Sushant Lok", "Sohna Road", "MG Road", "Sector 56"],
  },
  {
    slug: "faridabad",
    name: "Faridabad",
    tagline: "Home healthcare across Faridabad.",
    coverage: "NIT Faridabad, Old Faridabad, Sector 15–89, Neharpar",
    pincodes: "121001 – 121010",
    image: "https://images.unsplash.com/photo-1587474260584-136574528ed5?q=80&w=1600&auto=format&fit=crop",
    responseTime: "Within 3 hours",
    description:
      "KinFlex delivers home nursing, critical care, and elder care across Faridabad — NIT, Old Faridabad, and all major sectors. Our nurses are trained, verified, and just a call away.",
    landmarks: ["NIT", "Old Faridabad", "Sector 15", "Sector 21", "Sector 89", "Neharpar"],
  },
];

// ===== 9 WHY-CHOOSE POINTS =====
export const WHY_CHOOSE = [
  { title: "Verified Professionals", desc: "Every nurse & caretaker is background-checked and certified.", icon: "ShieldCheck" },
  { title: "Background Verified Staff", desc: "Police-verified, ID-checked, and reference-vetted.", icon: "UserCheck" },
  { title: "Experienced Nurses", desc: "GNM / BSc qualified with ICU-level clinical experience.", icon: "Stethoscope" },
  { title: "Emergency Support", desc: "Rapid deployment for urgent home care across Delhi NCR.", icon: "Siren" },
  { title: "24×7 Availability", desc: "Round-the-clock nursing, care & call support — always on.", icon: "Clock3" },
  { title: "Affordable Packages", desc: "Transparent pricing, flexible daily/weekly/monthly plans.", icon: "BadgeIndianRupee" },
  { title: "Fast Response", desc: "Same-day visits across Delhi NCR for most bookings.", icon: "Zap" },
  { title: "Personalized Care", desc: "Custom care plans built around each patient's condition.", icon: "Heart" },
  { title: "Trusted by Families", desc: "2,500+ families across NCR count on KinFlex daily.", icon: "Users" },
];

// ===== HOW IT WORKS =====
export const PROCESS = [
  { step: "01", title: "Call Us", desc: "Reach us via call, WhatsApp, or booking form — we respond within minutes." },
  { step: "02", title: "Medical Assessment", desc: "Our clinical team assesses needs, medical history & care plan." },
  { step: "03", title: "Healthcare Professional Assigned", desc: "Matched nurse / caretaker / doctor deployed with full briefing." },
  { step: "04", title: "Treatment Starts at Home", desc: "Care begins at home with ongoing supervision & family updates." },
];

// ===== TESTIMONIALS =====
export const TESTIMONIALS = [
  {
    name: "Anjali Mehra",
    role: "Daughter of ICU Discharge Patient",
    location: "Gurugram",
    rating: 5,
    text: "KinFlex's critical care nurses handled my father's post-ICU recovery flawlessly. Ventilator care, Ryle's tube, injections — all delivered with skill and warmth.",
    image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=300&auto=format&fit=crop",
  },
  {
    name: "Rahul Kapoor",
    role: "Son of Elderly Parent",
    location: "Noida",
    rating: 5,
    text: "The caretaker assigned to my 82-year-old mother became family. Punctual, gentle, professional. Elder care done right.",
    image: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?q=80&w=300&auto=format&fit=crop",
  },
  {
    name: "Dr. Priya Singh",
    role: "Post-Operative Patient",
    location: "Delhi",
    rating: 5,
    text: "After my surgery their post-op nurse did dressings flawlessly and monitored vitals daily. Genuinely comforting during recovery.",
    image: "https://images.unsplash.com/photo-1594824476967-48c8b964273f?q=80&w=300&auto=format&fit=crop",
  },
  {
    name: "Sandeep Yadav",
    role: "Father of Newborn",
    location: "Faridabad",
    rating: 5,
    text: "Their baby care nurse supported my wife through the first weeks. Lactation help, newborn hygiene — total peace of mind.",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=300&auto=format&fit=crop",
  },
  {
    name: "Meera Sharma",
    role: "Daughter, Elder Care",
    location: "Ghaziabad",
    rating: 5,
    text: "Booked physiotherapy for my mother after her knee surgery. She's walking again in 4 weeks. Grateful to the KinFlex team.",
    image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?q=80&w=300&auto=format&fit=crop",
  },
];

// ===== FAQ =====
export const FAQS = [
  { q: "Are your nurses and staff verified?", a: "Yes. Every caregiver is police-verified, background-checked, medically certified, and continuously trained before deployment." },
  { q: "Is 24×7 home nursing available?", a: "Absolutely. We provide 12-hour and 24-hour nursing shifts, round-the-clock, across Delhi NCR." },
  { q: "Do you provide emergency home healthcare?", a: "Yes. Our rapid-response team can deploy within 2–3 hours for urgent bookings across Delhi NCR." },
  { q: "Can you set up ICU care at home?", a: "Yes — we set up a full home ICU with ventilator, monitors, ICU bed, oxygen, and 24×7 critical care nurses." },
  { q: "What are your service charges?", a: "Pricing depends on service type, hours, and patient condition. Contact us for a transparent, no-obligation quote." },
  { q: "Which areas do you serve?", a: "Delhi, Noida, Greater Noida, Ghaziabad, Gurugram and Faridabad — plus pan-India for special cases." },
  { q: "How quickly can staff arrive?", a: "Same-day visits are standard. Emergency cases in Delhi NCR are prioritised and deployed within a few hours." },
  { q: "Do you offer medical equipment on rent?", a: "Yes — ICU beds, ventilators, oxygen concentrators, wheelchairs, BiPAP/CPAP and more, with delivery & installation." },
  { q: "Can we get a doctor to visit at home?", a: "Yes. General physicians and specialist doctors visit at home. Same-day slots often available." },
];

// ===== BLOG ARTICLES (full content) =====
export const BLOGS = [
  {
    slug: "home-icu-setup-guide",
    title: "Setting Up an ICU at Home: A Complete Guide for Families",
    excerpt: "Equipment, staffing, cost, safety and everything else families need to know about home ICU setup in Delhi NCR.",
    image: "https://images.unsplash.com/photo-1581056771107-24ca5f033842?q=80&w=1600&auto=format&fit=crop",
    author: "KinFlex Clinical Team",
    date: "2026-04-18",
    updated: "2026-04-22",
    tags: ["ICU Setup", "Home Healthcare"],
    metaTitle: "Home ICU Setup Guide for Delhi NCR Families | KinFlex",
    metaDescription: "Complete guide to setting up an ICU at home — equipment, cost, staffing, and safety. Written by KinFlex's clinical team, verified for accuracy.",
    toc: ["What is a Home ICU?", "When to Consider It", "Equipment You Need", "Staffing", "Cost & Timelines", "Safety & Infection Control", "FAQs"],
    content: [
      { h: "What is a Home ICU?", p: "A home ICU (Intensive Care Unit) recreates hospital-grade critical care in a patient's home. It combines medical equipment — ventilator, monitor, ICU bed, oxygen, suction — with a trained team of critical care nurses under doctor supervision. For long-term ventilator-dependent patients, palliative cases, or ICU-discharge patients still needing continuous monitoring, home ICU offers comparable clinical quality at a significantly lower cost, with all the psychological benefits of being at home." },
      { h: "When to Consider a Home ICU", p: "Home ICU is appropriate when the patient is medically stable but requires continuous monitoring or ventilator support. Typical candidates include long-term ventilator patients, coma patients, advanced neurological illness, cancer palliation, and complex post-surgical recovery. It's not appropriate for acute deteriorating cases — those still need hospital ICU." },
      { h: "Equipment You Need", p: "Core equipment: an electric ICU bed, portable ICU-grade ventilator, multi-parameter monitor (ECG, SpO₂, NIBP, temperature, respiration), oxygen concentrator or cylinder backup, suction machine, and infection-control supplies. Optional additions: air mattress for pressure sore prevention, BiPAP for weaning trials, and a portable ultrasound where needed." },
      { h: "Staffing: Nurses & Supervision", p: "A safe home ICU needs 24×7 nurse coverage — typically 2–3 critical care nurses on rotation. All nurses must be ICU-experienced, ideally with 2+ years of hospital ICU practice. A supervising clinical lead and the treating doctor should stay on-call. Family caregivers are trained on basic emergency response." },
      { h: "Cost & Timelines", p: "Home ICU setup is typically 40–60% cheaper than a private hospital ICU on a monthly basis. Setup usually takes 4–8 hours from confirmation. Costs vary based on equipment configuration and staffing model; a transparent quote is provided upfront by any credible provider." },
      { h: "Safety & Infection Control", p: "Strict infection-control matters more at home than in a hospital because the environment isn't sterile. Hand hygiene, PPE, sterile suction, tube changes on schedule, and daily hygiene routines are non-negotiable. A good provider audits these regularly." },
    ],
    faqs: [
      { q: "How quickly can a home ICU be set up?", a: "Usually within 4–8 hours of confirmation across Delhi NCR." },
      { q: "Is home ICU as safe as a hospital ICU?", a: "For clinically stable patients requiring ongoing monitoring — yes. For acute deteriorating cases, hospital ICU is safer." },
      { q: "Do I need a doctor to visit?", a: "The treating doctor coordinates on video/call typically. Home doctor visits can also be arranged periodically." },
    ],
  },
  {
    slug: "elderly-care-delhi-ncr",
    title: "How to Choose the Right Elder Care in Delhi NCR (2026)",
    excerpt: "A practical guide for families deciding between caretakers, GDAs, nurses and full-time elder care.",
    image: "https://images.unsplash.com/photo-1758691462477-976f771224d8?crop=entropy&cs=srgb&fm=jpg&q=85",
    author: "KinFlex Clinical Team",
    date: "2026-04-10",
    updated: "2026-04-15",
    tags: ["Elder Care", "Delhi NCR"],
    metaTitle: "How to Choose Elder Care in Delhi NCR — Guide 2026 | KinFlex",
    metaDescription: "Practical guide to choosing the right elder care in Delhi NCR — caretakers vs nurses vs GDAs. Cost, verification, and what to look for.",
    toc: ["Types of Elder Care", "Caretaker vs GDA vs Nurse", "How to Verify Staff", "Red Flags", "Cost Comparison", "FAQs"],
    content: [
      { h: "Types of Elder Care", p: "Home elder care in India generally comes in three tiers — companion caretakers (for company + light routines), certified GDAs (for bedside routines like feeding, hygiene, mobility), and qualified nurses (for medication, wound care, injections, monitoring). The right choice depends on the elder's clinical condition and daily routine." },
      { h: "Caretaker vs GDA vs Nurse", p: "A companion caretaker is best when the elder is mostly independent and needs company + light help. A GDA is right when the elder is semi-dependent — needs feeding, hygiene, positioning. A nurse is required when there are ongoing clinical tasks — medication, wound care, catheter care, or complex monitoring." },
      { h: "How to Verify Staff", p: "Always ask for police verification, ID proof, medical certification (for nurses), and hospital experience. Reputable providers do all this by default. Also ask about the supervisor structure — who checks on the caregiver, and how often?" },
      { h: "Red Flags to Watch For", p: "Avoid providers who: can't produce verification documents, promise same-day placement without any assessment, quote significantly below market rates, don't offer supervisor visits, or refuse to sign a written agreement. Elder care is a long-term relationship; quality matters more than price." },
      { h: "Cost Comparison (Delhi NCR, 2026)", p: "Companion caretakers: ₹15–25k/month. GDAs: ₹18–30k/month. Nurses: ₹35–65k/month. 24×7 live-in vs shift-based pricing differs. Always ask about replacement policy and cancellation terms." },
    ],
    faqs: [
      { q: "Which is better — full-time or day-shift care?", a: "Full-time (24×7 live-in) is better when the elder is significantly dependent. Day-shift works for semi-independent elders." },
      { q: "How do I know if my parent needs a nurse or GDA?", a: "If daily tasks include medication, injections, wound care or monitoring — nurse. If it's mainly hygiene, feeding, mobility — GDA is enough." },
      { q: "What if I don't like the caregiver assigned?", a: "Every reputable provider replaces staff quickly at family request. Ask for this in writing before signing on." },
    ],
  },
  {
    slug: "post-op-recovery-tips",
    title: "10 Home Recovery Tips After Major Surgery",
    excerpt: "From wound care to physiotherapy — what to expect and how to recover safely at home.",
    image: "https://images.unsplash.com/photo-1579684385127-1ef15d508118?q=80&w=1600&auto=format&fit=crop",
    author: "KinFlex Clinical Team",
    date: "2026-04-02",
    updated: "2026-04-05",
    tags: ["Post-Op", "Recovery"],
    metaTitle: "10 Home Recovery Tips After Major Surgery | KinFlex",
    metaDescription: "10 practical tips for safe, faster recovery at home after major surgery — wound care, physio, medication, family training and red flags.",
    toc: ["Wound Care", "Physiotherapy", "Medication", "Nutrition", "Sleep", "Red Flags", "FAQs"],
    content: [
      { h: "1. Take Wound Care Seriously", p: "Follow the discharge dressing plan strictly. Keep the wound dry and sterile. If you notice redness, pus, warmth, foul smell or fever — call your surgeon immediately. A trained nurse can handle dressings at home to reduce infection risk." },
      { h: "2. Start Physiotherapy Early", p: "For orthopaedic, cardiac and spine surgeries, early physiotherapy accelerates recovery and reduces stiffness. Even 15–20 minutes daily helps. Home physio saves the effort of travelling to a clinic while recovering." },
      { h: "3. Take Medications on Schedule", p: "Missed antibiotic doses can cause resistant infections. A pill organiser or a nursing visit ensures nothing gets missed. Never stop antibiotics early — always finish the prescribed course." },
      { h: "4. Prioritise Nutrition", p: "Protein-rich meals (dal, egg, chicken, fish, paneer) fuel healing. Include vitamin C (citrus, amla) and zinc (nuts, seeds). Stay hydrated — 2–3L of water daily unless restricted by your doctor." },
      { h: "5. Sleep Well", p: "Sleep is when healing happens. Set up a comfortable bed (hospital bed if needed), reduce noise, and stick to a routine. Speak to your doctor about pain control at night if pain disturbs sleep." },
      { h: "6. Watch for Red Flags", p: "Call your doctor immediately if you see: fever, worsening pain, excessive bleeding, swelling with warmth (possible clot), shortness of breath, or wound infection signs. Trust your instincts." },
    ],
    faqs: [
      { q: "How long is typical post-op recovery?", a: "Depends on the surgery — 2 weeks for minor, 6–12 weeks for major surgeries." },
      { q: "Should I hire a home nurse after major surgery?", a: "For 2–4 weeks after major surgery, a nurse for dressings, injections, and monitoring is highly recommended." },
      { q: "When can I resume normal activity?", a: "Always follow your surgeon's advice. Overdoing it early is the top cause of complications." },
    ],
  },
  {
    slug: "physiotherapy-at-home-benefits",
    title: "Home Physiotherapy vs Clinic: What's Better for Recovery?",
    excerpt: "Pros, cons and evidence — when home physio wins and when a clinic makes more sense.",
    image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=1600&auto=format&fit=crop",
    author: "KinFlex Clinical Team",
    date: "2026-03-28",
    updated: "2026-04-01",
    tags: ["Physiotherapy", "Rehab"],
    metaTitle: "Home Physio vs Clinic — Which Works Better? | KinFlex",
    metaDescription: "Detailed comparison of home physiotherapy vs clinic-based physio — recovery outcomes, cost, comfort, and clinical context.",
    toc: ["Home vs Clinic — the Trade-offs", "Best For Home", "Best For Clinic", "Cost Comparison", "FAQs"],
    content: [
      { h: "The Trade-offs", p: "Home physio wins on convenience, one-to-one attention, and adapting to the home environment. Clinic physio wins on advanced equipment access (ultrasound therapy, gym-grade weights, etc.). For most rehab cases, home physio outcomes are comparable — sometimes better because compliance is higher when the therapist visits." },
      { h: "When Home Physio is Best", p: "Elderly patients, post-op patients still with limited mobility, stroke and paralysis patients (where the home environment matters for real-world recovery), chronic pain patients preferring privacy, and busy professionals with unpredictable schedules." },
      { h: "When Clinic Makes Sense", p: "Sports injury recovery needing gym equipment, chronic pain requiring advanced modalities (SWD, IFT, ultrasound), and cases where group therapy might help motivation." },
      { h: "Cost Comparison", p: "Home physio in Delhi NCR: ₹700–1,200 per session. Clinic physio: ₹400–800 per session but add travel time and cost. Package rates often make home physio comparable or cheaper for elderly patients." },
    ],
    faqs: [
      { q: "Are outcomes really comparable?", a: "Yes — recent studies show home physio matches or beats clinic outcomes for stroke, post-op, and geriatric rehab." },
      { q: "Can I have both home + clinic sessions?", a: "Yes — hybrid models work well for many patients." },
    ],
  },
  {
    slug: "tracheostomy-care-at-home",
    title: "Tracheostomy Care at Home: A Family Handbook",
    excerpt: "Suction, cleaning, tube change, and emergency response — what every trach family should know.",
    image: "https://images.unsplash.com/photo-1631815589968-fdb09a223b1e?q=80&w=1600&auto=format&fit=crop",
    author: "KinFlex Clinical Team",
    date: "2026-03-20",
    updated: "2026-03-24",
    tags: ["Tracheostomy", "Critical Care"],
    metaTitle: "Tracheostomy Care at Home — Family Handbook | KinFlex",
    metaDescription: "Complete handbook for families caring for tracheostomy patients at home — suction, cleaning, tube change, emergency response.",
    toc: ["Understanding Tracheostomy", "Daily Care", "Suction Technique", "Emergency Response", "When to Call the Doctor", "FAQs"],
    content: [
      { h: "Understanding Tracheostomy", p: "A tracheostomy is a small surgical opening in the neck that houses a breathing tube. It's needed when the upper airway is obstructed, when a patient is on prolonged ventilation, or in advanced neuro conditions. Home care requires strict sterile technique — the tube is a direct path to the lungs." },
      { h: "Daily Care Essentials", p: "Cleaning the inner cannula 2–3 times daily. Stoma-site care (clean edges, watch for redness). Humidification to prevent dry secretions. Regular suction. And keeping an emergency kit ready — extra tube, obturator, syringe, gauze." },
      { h: "Suction Technique — Safely", p: "Wash hands or wear sterile gloves. Use a sterile catheter. Insert without suction, then withdraw with suction for 5–10 seconds max. Never suction for longer — it drops oxygen. Watch the patient's face and SpO₂ throughout." },
      { h: "Emergency Response", p: "If the tube gets blocked and secretions can't be cleared: try suction. If not resolved, remove the inner cannula and clean/replace it. If the whole tube comes out — insert the replacement tube using the obturator. Call for help immediately." },
      { h: "When to Call the Doctor", p: "Fever, thick / green secretions, bleeding from the stoma, severe breathlessness, or if the tube keeps blocking. Trust your instincts — better to call once too often than too late." },
    ],
    faqs: [
      { q: "How often should the tube be changed?", a: "Every 4–8 weeks typically, or as advised by the treating ENT." },
      { q: "Can I bathe a tracheostomy patient?", a: "Yes — with care to prevent water entering the stoma. Sponge baths are safer than showers." },
      { q: "How do we know if there's an infection?", a: "Fever, foul-smelling or coloured secretions, redness at the stoma, breathlessness. Any of these — call the doctor." },
    ],
  },
  {
    slug: "medical-equipment-rental-guide",
    title: "Renting Medical Equipment in Delhi NCR: What You Should Know",
    excerpt: "A practical guide to renting hospital beds, oxygen, ventilators and more — before you sign anything.",
    image: "https://images.unsplash.com/photo-1587854692152-cbe660dbde88?q=80&w=1600&auto=format&fit=crop",
    author: "KinFlex Clinical Team",
    date: "2026-03-12",
    updated: "2026-03-16",
    tags: ["Equipment", "Home Care"],
    metaTitle: "Renting Medical Equipment in Delhi NCR — Practical Guide | KinFlex",
    metaDescription: "Family guide to renting medical equipment in Delhi NCR — pricing, quality checks, delivery, service, and what to ask before booking.",
    toc: ["Why Rent vs Buy", "What to Rent First", "Quality Checks", "Pricing Range", "Service Terms to Confirm", "FAQs"],
    content: [
      { h: "Why Rent vs Buy", p: "For temporary needs (weeks to months), renting saves 60–80% of purchase cost — plus you avoid the hassle of resale. For long-term needs (>12 months), buying may make sense; but even then, servicing and warranty are your responsibility." },
      { h: "What to Rent First", p: "Priority order for setting up home care: ICU bed with mattress → oxygen concentrator (if prescribed) → multi-para monitor (if home ICU) → suction machine (for trach / bedridden) → wheelchair for transfers. Add specific equipment as your care plan evolves." },
      { h: "Quality Checks Before Booking", p: "Ask to see the equipment brand and model. For ventilators and monitors, insist on medical-grade brands (Philips, GE, Mindray, Drager). Ask about sanitisation between rentals. Confirm calibration dates for monitors." },
      { h: "Pricing Range (Delhi NCR, 2026)", p: "ICU bed: ₹3,500–5,500/month. Oxygen concentrator 5L: ₹4,500–7,000/month. BiPAP: ₹5,500–8,500/month. Portable ventilator: ₹40,000–70,000/month. Wheelchair: ₹1,500–3,000/month. Prices vary by brand and duration." },
      { h: "Service Terms to Confirm", p: "Delivery / installation / pickup — usually free. Replacement policy for breakdowns — should be within 4–6 hours. Consumables (masks, tubes) — separate cost or included? Cancellation / refund terms." },
    ],
    faqs: [
      { q: "Do I need a deposit?", a: "Usually yes — a refundable deposit is standard. Ask for a receipt." },
      { q: "Can I extend the rental?", a: "Yes — reputable providers extend without any hassle." },
      { q: "What if the equipment breaks down?", a: "You should get a free replacement within a few hours — this is standard for good providers." },
    ],
  },
];

// ===== GOOGLE-STYLE REVIEWS =====
export const GOOGLE_REVIEWS = {
  averageRating: 4.9,
  totalReviews: 348,
  reviewUrl: "https://g.page/r/kinflex-home-healthcare",
  highlights: [
    { name: "Priyanka R.", text: "Booked a nurse within 2 hours. Excellent care for my father post-surgery.", rating: 5 },
    { name: "Vikram T.", text: "KinFlex set up a full ICU at home for my mother. The team was outstanding.", rating: 5 },
    { name: "Neha K.", text: "The physiotherapist was patient and professional. Truly premium service.", rating: 5 },
  ],
};

// ===== STATS =====
export const STATS_DEFAULTS = {
  patients_served: 2500,
  professional_staff: 180,
  emergency_support: "24×7",
  years_experience: 8,
};

export const TRUST_BADGES = [
  { icon: "ShieldCheck", label: "Verified Nurses" },
  { icon: "Clock3", label: "24×7 Support" },
  { icon: "Zap", label: "Same Day Visit" },
  { icon: "BadgeIndianRupee", label: "Affordable Pricing" },
];

// ===== SERVICE × LOCATION SEO combos (dynamic pages) =====
export const SERVICE_LOCATIONS = [
  { serviceSlug: "home-nursing", locationSlug: "noida", title: "Home Nursing in Noida" },
  { serviceSlug: "home-nursing", locationSlug: "delhi", title: "Home Nursing in Delhi" },
  { serviceSlug: "home-nursing", locationSlug: "gurugram", title: "Home Nursing in Gurugram" },
  { serviceSlug: "home-nursing", locationSlug: "ghaziabad", title: "Home Nursing in Ghaziabad" },
  { serviceSlug: "home-nursing", locationSlug: "faridabad", title: "Home Nursing in Faridabad" },
  { serviceSlug: "home-nursing", locationSlug: "greater-noida", title: "Home Nursing in Greater Noida" },
  { serviceSlug: "physiotherapy-at-home", locationSlug: "noida", title: "Physiotherapy in Noida" },
  { serviceSlug: "physiotherapy-at-home", locationSlug: "delhi", title: "Physiotherapy in Delhi" },
  { serviceSlug: "physiotherapy-at-home", locationSlug: "gurugram", title: "Physiotherapy in Gurugram" },
  { serviceSlug: "icu-setup-at-home", locationSlug: "noida", title: "ICU Setup in Noida" },
  { serviceSlug: "icu-setup-at-home", locationSlug: "delhi", title: "ICU Setup in Delhi" },
  { serviceSlug: "elder-care", locationSlug: "noida", title: "Elder Care in Noida" },
  { serviceSlug: "elder-care", locationSlug: "delhi", title: "Elder Care in Delhi" },
  { serviceSlug: "elder-care", locationSlug: "gurugram", title: "Elder Care in Gurugram" },
  { serviceSlug: "critical-care-nurse", locationSlug: "delhi", title: "Critical Care Nurse in Delhi" },
  { serviceSlug: "critical-care-nurse", locationSlug: "noida", title: "Critical Care Nurse in Noida" },
];

// ===== GALLERY images =====
export const GALLERY = [
  { src: "https://images.unsplash.com/photo-1758691462477-976f771224d8?crop=entropy&cs=srgb&fm=jpg&q=85", alt: "Nurse helping elderly patient at home" },
  { src: "https://images.pexels.com/photos/5452268/pexels-photo-5452268.jpeg?auto=compress&cs=tinysrgb&h=650", alt: "Bedridden patient care" },
  { src: "https://images.unsplash.com/photo-1579684385127-1ef15d508118?q=80&w=1200&auto=format&fit=crop", alt: "Post surgical wound care at home" },
  { src: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?q=80&w=1200&auto=format&fit=crop", alt: "ICU-trained nurse at home" },
  { src: "https://images.unsplash.com/photo-1581056771107-24ca5f033842?q=80&w=1200&auto=format&fit=crop", alt: "Home ICU setup with monitor" },
  { src: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=1200&auto=format&fit=crop", alt: "Physiotherapy at home session" },
  { src: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?q=80&w=1200&auto=format&fit=crop", alt: "Home nursing with medication" },
  { src: "https://images.unsplash.com/photo-1631815587646-b85a1bb027e1?q=80&w=1200&auto=format&fit=crop", alt: "Oxygen therapy at home" },
];

// ===== JSON-LD: MedicalBusiness / LocalBusiness org schema =====
export const ORG_JSONLD = {
  "@context": "https://schema.org",
  "@type": ["MedicalBusiness", "LocalBusiness"],
  name: "KinFlex Home Healthcare",
  url: "https://kinflexhomehealthcare.com",
  logo: "https://customer-assets.emergentagent.com/job_c6db479d-f053-4142-8fe3-95cbdea25844/artifacts/s6a1d4kc_IMG-20260505-WA0002.jpg",
  image: "https://customer-assets.emergentagent.com/job_c6db479d-f053-4142-8fe3-95cbdea25844/artifacts/s6a1d4kc_IMG-20260505-WA0002.jpg",
  description: "Premium home healthcare in Delhi NCR — 24×7 verified nurses, ICU-grade critical care, physiotherapy, elder care and medical equipment rental.",
  telephone: "+91-8796465422",
  email: "info@kinflexhomehealthcare.com",
  areaServed: ["Delhi", "Noida", "Greater Noida", "Ghaziabad", "Gurugram", "Faridabad"],
  address: {
    "@type": "PostalAddress",
    addressCountry: "IN",
    addressRegion: "Delhi NCR",
  },
  priceRange: "₹₹",
  sameAs: [
    "https://www.instagram.com/kinflexhomehealthcare",
    "https://www.linkedin.com/in/kinflex-home-healthcare-677993408",
    "https://youtube.com/@kinflexhomehealthcare",
  ],
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: "4.9",
    reviewCount: "348",
  },
};

// ===== Legal / policy pages content =====
export const LEGAL_PAGES = {
  privacy: {
    slug: "privacy-policy",
    title: "Privacy Policy",
    updated: "2026-05-01",
    intro: "This Privacy Policy explains how KinFlex Home Healthcare collects, uses, and safeguards the personal and medical information of patients, families, and visitors to our website.",
    sections: [
      { h: "Information We Collect", p: "We collect only what's needed to serve you — name, phone, email, city, service preference, and (where relevant) basic medical context you choose to share for care planning. Our website analytics collect anonymised traffic data to improve user experience." },
      { h: "How We Use It", p: "To respond to booking and contact enquiries, plan appropriate care, coordinate with your treating doctor, send appointment updates, and — with your explicit consent — occasional health-related communications. We do not sell your data. Ever." },
      { h: "Medical Information", p: "Any medical information shared with our clinical team is treated with utmost confidentiality. Access is limited to the assigned nurses, supervisor, and coordinating doctor — under standard clinical confidentiality obligations." },
      { h: "Data Security", p: "We use industry-standard encryption for our website and internal systems. Physical files (where kept) are stored securely at our office. Employees sign confidentiality agreements." },
      { h: "Your Rights", p: "You can request access to your data, corrections, or deletion at any time by writing to info@kinflexhomehealthcare.com. We honour all reasonable requests within 30 days." },
      { h: "Cookies", p: "Our website uses minimal cookies for essential functionality and analytics. You can disable cookies in your browser, but some site features may not work." },
      { h: "Contact", p: "For any privacy-related questions, write to info@kinflexhomehealthcare.com or call 8796465422." },
    ],
  },
  terms: {
    slug: "terms-and-conditions",
    title: "Terms & Conditions",
    updated: "2026-05-01",
    intro: "By booking KinFlex Home Healthcare services, you agree to the following terms.",
    sections: [
      { h: "Scope of Services", p: "KinFlex provides supportive home healthcare, nursing, caregiving and medical equipment rental. All medical decisions must be made by qualified physicians. Our staff operate under the guidance of the treating doctor." },
      { h: "Booking & Payment", p: "Bookings can be made via phone, WhatsApp, website form, or in person. Payment is per the quoted rate and schedule. A refundable security deposit may apply for equipment rentals." },
      { h: "Client Responsibilities", p: "You agree to share accurate patient information, honour scheduled visits, provide safe access to the home, and follow reasonable care protocols recommended by our team." },
      { h: "Cancellation", p: "Cancellations follow our Cancellation Policy (linked separately). We aim to be fair — please read that document for specifics." },
      { h: "Liability", p: "KinFlex staff exercise professional care and follow accepted standards. Our liability is limited to service fees paid. Medical outcomes depend on many factors beyond our control." },
      { h: "Governing Law", p: "These terms are governed by Indian law. Any disputes fall under Delhi NCR jurisdiction." },
    ],
  },
  refund: {
    slug: "refund-policy",
    title: "Refund Policy",
    updated: "2026-05-01",
    intro: "We aim for full satisfaction. This Refund Policy explains how refunds work.",
    sections: [
      { h: "Prepaid Services", p: "If you have prepaid for services not yet rendered, we refund 100% of the unused amount — no questions asked, within 7 working days." },
      { h: "Partial Service", p: "If services are partly delivered and you wish to stop, we refund the pro-rated unused portion, minus any deployment costs already incurred." },
      { h: "Equipment Rentals", p: "Rental refunds are pro-rated based on days used. Security deposits are refunded fully once equipment is returned in good condition." },
      { h: "How to Request", p: "Email info@kinflexhomehealthcare.com or WhatsApp us. Please share the booking reference. Refunds are processed to the original payment method." },
    ],
  },
  cancellation: {
    slug: "cancellation-policy",
    title: "Cancellation Policy",
    updated: "2026-05-01",
    intro: "Life happens. Our cancellation policy is fair and flexible.",
    sections: [
      { h: "Cancelling a Nurse / GDA Booking", p: "Cancel any time before deployment — no charge. If cancellation happens after nurse deployment but before shift start, a nominal deployment fee may apply." },
      { h: "Cancelling During a Shift", p: "If you wish to end a shift midway, we bill only for the hours completed rounded to the nearest half-hour." },
      { h: "Long-Term Bookings", p: "For weekly / monthly bookings, cancellation requires 24 hours notice for the remaining period." },
      { h: "Equipment Cancellation", p: "Equipment rentals can be returned at any time; billing is pro-rated to the exact days used." },
      { h: "Emergency Cancellations", p: "For genuine emergencies (patient hospitalised, death, etc.), we waive cancellation fees case-by-case." },
    ],
  },
  medicalDisclaimer: {
    slug: "medical-disclaimer",
    title: "Medical Disclaimer",
    updated: "2026-05-01",
    intro: "Please read this disclaimer carefully.",
    sections: [
      { h: "Supportive Care Only", p: "KinFlex provides supportive nursing and caregiving services. All medical decisions, prescriptions, diagnoses, and treatment plans are the responsibility of qualified physicians. Our staff execute the treating doctor's plan and provide skilled care." },
      { h: "Not a Substitute for Emergency Care", p: "In case of a medical emergency (severe chest pain, severe breathlessness, unconsciousness, uncontrolled bleeding, stroke symptoms), call 112 (India emergency) or rush to the nearest hospital immediately. KinFlex is not a replacement for emergency medical services." },
      { h: "Content on this Website", p: "Blog articles and website content are for general information only. They do not constitute medical advice. Always consult a qualified doctor for personalised medical guidance." },
      { h: "No Doctor-Patient Relationship via Website", p: "Reading our website or contacting us does not create a doctor-patient relationship. Formal clinical care begins only after a documented care agreement is in place." },
    ],
  },
};
